module.exports = __WEBPACK_EXTERNAL_MODULE_91__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 91
// module chunks = 0